import {Structures} from 'octopus-model';

export const authentication = {
    displayLoginLogo: true,
    enableSSO: false,
    enableLocalCache: true,
    floatLabelControl: 'always', // 'always' | 'never' | 'auto'
    firstConnexionRedirection: {
        default: '/achievement',
        trainer: '/home',
    },
    overrideDefaultRouteByRole: {
        learner: '/achievement',
        trainer: 'lessons/list/models',
    },
    activeChangePasswordStrategy: true,
    onlyLoginWithMail: false,
    displayGARHelper: true,
    enableGAR: true,
    urlGarRegister: 'https://www.citizencode.net/inscription-gar/',
    entButtonAllowedWithoutRules: false,// citizen-code provide dynamic rules for show or not ent button
    useUrlGarRegister: true,
    newsletterRulesAddNoSsoUser: true,
    activateAuthenticationByThirdParty: true,
    googleClientId: '887502420019-2uoritrnkl8g55e2se2qrape6otero59.apps.googleusercontent.com',
    facebookAppId: '1243606024389871',
    appleRedirectUri: '/auth/apple/callback',
    appleClientId: 'net.citizencode.auth',
};
